module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/time-a905b87db2f0866643e07304cf1f2a72.svg";